import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import InstallDesktopTwoToneIcon from '@mui/icons-material/InstallDesktopTwoTone';
import '../Styles/StyleHome.css';
import Person2TwoToneIcon from '@mui/icons-material/Person2TwoTone';
import HomeIcon from '@mui/icons-material/Home';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Langue from './Langue';
import MenuSearchDialog from './MenuSearchDialog';
import SearchIcon from '@mui/icons-material/Search';
import Tooltip from '@mui/material/Tooltip';
import Data from '../Data/Data.json';
import MyMenu from '../Models/Menu';
import { useAuthHeader, useAuthUser, useSignOut } from '../Services/Auth/sessionAuth';
import Utilisateur from '../Models/Utilisateur';
import { Link, useNavigate } from 'react-router-dom';
import Mode from './Mode';
import { Book, Timelapse } from '@mui/icons-material';
import i18next from 'i18next';
import Fermer from "../Res/journeFerme.png";
import Ouvert from "../Res/journeOuverte.png";
import ParamsPicklist from '../Types/ParamsPicklist';
import { Crypter } from '../Functions/Security/Crypter';
import axios from 'axios';
import Swal from 'sweetalert2';

const drawerWidth = 240;
const options: Option[] = [
  { key: "p", name: "profil", link: "/user/profil" },
  { key: "s", name: "setting", link: "/setting" },
  { key: "l", name: "logout", link: "/login" },
]

interface Option {
  key: string,
  name: string,
  link: string
}


export function MenuAppbar() {
  //const user = JSON.parse(sessionStorage.getItem(Data.LocalVariable.user)+"")
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const navigate = useNavigate()
  const signOut = useSignOut()

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [isOpen, setIsOpen] = React.useState<boolean>();

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [searchOpen, setSearchOpen] = React.useState(false);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [date, setDate] = React.useState((new Date(user.datjour)).toLocaleDateString(i18next.language) + " " + (new Date()).toLocaleTimeString(i18next.language));


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };
  
  const handleCloseUserMenu = (key: string, link: string) => {
    if (key == "l") {
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.authLogout,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
        //data: data
      };

      axios.request(config)
        .then((response) => {
          signOut()
          let res = JSON.parse(Crypter.decrypt(response.data))
          // setLoading(false)
        })
        .catch((error) => {
          // setLoading(false)
          Swal.fire({
            title: "Déconnexion",
            text: error.message + "",
            icon: 'error',
            cancelButtonColor: "darkred",
            cancelButtonText: "Cloase",
          })
        });
    } else {
      if(link != "backdropClick")
        navigate(link)
      setAnchorElUser(null);
    }
  };

  React.useEffect(() => {
    let mounted = true;

    const updateHeader = () => {
      if (mounted) {
        setDate((new Date(user.datjour)).toLocaleDateString(i18next.language) + " " + (new Date()).toLocaleTimeString(i18next.language));
        loadStatutOfDay();
      }
    };

    const timer = window.setInterval(updateHeader, 1000);
    updateHeader();

    return () => {
      mounted = false;
      window.clearInterval(timer);
    };
  }, [user.datjour, user.codage, authHeader, i18next.language]);

  // Raccourci clavier Ctrl+K / Cmd+K pour ouvrir la recherche d'habilitations
  React.useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setSearchOpen(true);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  function loadStatutOfDay() {
   // let search: ParamsPicklist = { CodeAgence: '', Table: "DATGEN", Colonne1: "CODAGE", Colonne2: "CDETAT", Init: user.codage, Colagence: '', Choix: 33 }
    let search: ParamsPicklist = { CodeAgence: '', Table: "DATGEN", Colonne1: "CODAGE", Colonne2: "CDETAT", Init: user.codage, Colagence: '', Choix: 35 }

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify(search))
      }
    };
    axios(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {
            let datas = res.Result.Table[0];
            if (datas.CDETAT == '50') {
              setIsOpen(true)
            }
            else {
              setIsOpen(false)
            }
          }
        }
      }).catch(() => { })
  }

  return (
    <>
      <AppBar
        id='AppBar'
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },

        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              mr: 2, display: { sm: 'none' }, backgroundColor: 'darkred', width: 20,
              height: 41
            }}
          >
            <MenuIcon />
          </IconButton>
          <Stack direction="row" spacing={2}>

            <Button className='buttap' size='small' startIcon={<Person2TwoToneIcon sx={{ color: 'white' }} />} ><p className='textbap'>{user.coduti + " - " + user.nomuti}</p></Button>
            <Button className='buttap' size='small' startIcon={<InstallDesktopTwoToneIcon sx={{ color: 'white' }} />} ><p className='textbap'>{user.group}</p></Button>
            <Button onClick={() => { navigate("/") }} className='buttap' size='small' startIcon={<HomeIcon sx={{ color: 'white' }} />} ><p className='textbap'>{user.agence}</p></Button>
            <Button className='buttap' size='small' startIcon={<Timelapse sx={{ color: 'white' }} />} ><p className='textbap'>{date}</p></Button>

            {isOpen != null ? <Button className='buttap' size='small' startIcon={<img width={30} src={isOpen ? Ouvert : Fermer} />} ><p className='textbap'>{"Journée comptable " + (isOpen ? "ouverte" : "Fermé")}</p></Button> : ""}
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>

            <Tooltip title="Rechercher un écran (Ctrl+K)">
              <IconButton
                size="large"
                color="inherit"
                aria-label="rechercher un ecran habilite"
                onClick={() => setSearchOpen(true)}
              >
                <SearchIcon />
              </IconButton>
            </Tooltip>
            <Langue />
            <Mode />

            <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
            >
              <Badge badgeContent={3} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-haspopup="true"
              color="inherit"
              onClick={handleOpenUserMenu}
            >
              <Avatar sx={{ border: 'solid' }} alt="Cindy Baker" src={user.photo} />
            </IconButton>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Menu
              sx={{ mt: 0.5 }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {options.map((option: Option) => (
                <MenuItem key={option.key} onClick={() => { handleCloseUserMenu(option.key, option.link) }}>
                  <Typography textAlign="center">{option.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <MenuSearchDialog open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>


  )
}